import React, { useContext } from "react";
import classnames from "classnames";

import Styles from "./Stories.module.scss";

import Story from "./story/Story";
import { AppContext } from "@vahak/core/dist/app-context";
import CustomCarousel from "@vahak/core/dist/components/custom-carousel/CustomCarousel";

const items = [
    {
        children: (
            <Story
                text="At Vahak, you will find healthy chaos that everyone wants to be a part of! There are enough challenges for everyone at every level."
                imgSrcLarge={`Punit-desktop.png`}
                author="Punit Chotia"
                authorPosition="Marketing Growth Head"
            />
        ),
        key: "1"
    },
    {
        children: (
            <Story
                text="Life at Vahak is the total package! Career growth, work environment, team spirit, employee wellness..we have it all! I actually enjoy coming to work on Mondays."
                imgSrcLarge={`akshathaempt.png`}
                author="Akshatha R"
                authorPosition="SDE (QA)"
            />
        ),
        key: "2"
    },
    {
        children: (
            <Story
                text="Here you will find diverse people which make a good competitive peer group that pushes your limits. Truly love the learning experience here ; great leadership who believes in YOU."
                imgSrcLarge={`varshapempt.png`}
                author="Varshap W"
                authorPosition="Backend Engineer"
            />
        ),
        key: "3"
    },
    {
        children: (
            <Story
                text="The perfect mix of liveliness and sincerity at Vahak create the ideal environment for me to work!"
                imgSrcLarge={`Ayaz-Desktop.png`}
                author="Ayaz Siddiqui"
                authorPosition="SDET"
            />
        ),
        key: "4"
    },
    {
        children: (
            <Story
                text="Working at Vahak is a healthy mix of engaging in interesting conversations with colleagues and taking up challenging tasks!"
                imgSrcLarge={`Ram_Story-desktop.png`}
                author="Rammurthy"
                authorPosition="Data Scientist"
            />
        ),
        key: "5"
    },
    {
        children: (
            <Story
                text="For me, this is more than a job. I’m investing my time, my knowledge and experience in a company that is investing in me"
                imgSrcLarge={`tanushreel.jpg`}
                author="Tanushree L"
                authorPosition="Social Media Head"
            />
        ),
        key: "6"
    },
    {
        children: (
            <Story
                text="The work environment is very friendly, team-oriented and laser-focused to change the landscape of Indian logistics."
                imgSrcLarge={`roja-k.JPG`}
                author="Roja K"
                authorPosition="Digital Marketing Manager"
            />
        ),
        key: "7"
    },
    {
        children: (
            <Story
                text="Vahak is a fast-growing company and a wonderful place to work!"
                imgSrcLarge={`abhay--k.jpg`}
                author="Abhay K"
                authorPosition="Customer Service Executive"
            />
        ),
        key: "8"
    },
    {
        children: (
            <Story
                text="The company treats you like a valued person, not just an employee. There is a lot of scope to experiment making it very creatively fulfilling"
                imgSrcLarge={`rajatempt.png`}
                author="Rajat S"
                authorPosition="National Head, offline sales and marketing"
            />
        ),
        key: "9"
    }
];

const Stories = () => {
    const { isMobile } = useContext(AppContext);
    return (
        <div className={classnames(Styles.wrapper)}>
            <h2>
                What{" "}
                <span data-hover="Our Crew" className={isMobile ? "" : "indaiText"}>
                    Our Crew
                </span>{" "}
                is saying
            </h2>
            <div className={Styles.storiesOuterWrapper}>
                <CustomCarousel
                    containerClass={Styles.carouselContainer}
                    rowClass={Styles.carouselRow}
                    itemClass={Styles.carouselItem}
                    activeClass={Styles.carouselActive}
                    prevNextBtnsClass={Styles.buttonsClass}
                    dotsClass={Styles.carouselDots}
                    length={items?.length}
                    scrollBy={1}
                    items={items?.map((data, index) => data.children)}
                />
            </div>
        </div>
    );
};

export default Stories;
